import {Trans} from 'react-i18next';
import React from 'react';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import AsyncApiIntegration from '../saasapi/apiintegration/async';
import {Redirect} from 'react-router';

const parent = {
  title: <Trans i18nKey="c.l.sidebar.11000.title">Server to Server API</Trans>,
  path: '/saas-api/api-integration',
};

export default [
  <SingleColumnLayout
    exact
    key="a"
    path="/saas-api/api-integration"
    component={AsyncApiIntegration}
    title={
      <Trans i18nKey="c.tutorial.task.api.integration.title">
        API Integration
      </Trans>
    }
    parents={[parent]}
  />,
  <Redirect key="e" exact from="/saas-api" to="/saas-api/api-integration" />,
];
